import enMessages from "lang/en-US.json";
import esMessages from "lang/es-MX.json";
import ptMessages from "lang/pt-BR.json";

const getMessages = (locale: string) => {
  const messages = {
    en: enMessages,
    es: esMessages,
    "pt-br": ptMessages,
  };

  return messages[locale] || ptMessages;
};
export default getMessages;
